import { ref } from 'vue'
import type { Ref } from 'vue'
import { useMenuBreadcrumbStore } from '../stores/useMenuBreadcrumbStore'
import type { MenuBreadcrumb } from '../entities/MenuBreadcrumb'
import type { TBreadcrumb_Props } from '~~/modules/design-system/components/t-breadcrumb/index.vue'
import { useHeadSchemaComposable } from '~~/modules/head/composables/useHeadSchemaComposable'
import type { HeadListItem } from '~~/modules/head/entities/HeadListItem'

export function useMenuBreadcrumb() {
  const breadCrumbMenuStore = useMenuBreadcrumbStore()

  const MenuBreadcrumbInstance: MenuBreadcrumb =
    breadCrumbMenuStore.getMenuBreadcrumb

  const TBreadcrumbPropsItemsInstance: Ref<TBreadcrumb_Props['items']> = ref([])

  type breadcrumbItem = TBreadcrumb_Props['items'][number]

  MenuBreadcrumbInstance.forEach(item => {
    const breadCrumbItem: breadcrumbItem = {
      name: item.name,
      url: item.selected ? '' : item.href,
    }

    TBreadcrumbPropsItemsInstance.value.push(breadCrumbItem)
  })

  const schemaItems: HeadListItem[] = []

  MenuBreadcrumbInstance.forEach((item, index) => {
    const breadCrumbItem: HeadListItem = {
      position: (index + 1) as HeadListItem['position'],
      name: item.name,
      url: routes().addDomain({ slug: item.href }),
    }

    schemaItems.push(breadCrumbItem)
  })

  const { breadcrumbSchema } = useHeadSchemaComposable()
  breadcrumbSchema(schemaItems)

  return { TBreadcrumbPropsItemsInstance }
}
